// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pill.css */

/* =========================
   Bottom dock (fixed)
   ========================= */
.glassMenuDock{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 24px;

  z-index: 9999;
  display: flex;
  justify-content: center;

  pointer-events: none;
}

.glassMenuDock > *{
  pointer-events: auto;
}

@media (max-width: 520px){
  .glassMenuDock{
    bottom: 14px;
  }
}

/* =========================
   Wide glass capsule bar
   ========================= */
.glassBar{
  position: relative;
  width: min(780px, calc(100vw - 32px));
  height: 56px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 8px;
  border-radius: 999px;

  font-family: Geist, Helvetica, Arial, sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.02em;

  color: rgba(252, 249, 248, 0.95);

  /* LESS FROSTED: lower blur, higher transparency */
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.22);

  backdrop-filter: blur(10px) saturate(190%) contrast(115%);
  -webkit-backdrop-filter: blur(10px) saturate(190%) contrast(115%);

  /* Liquid edge + depth */
  box-shadow:
    0 18px 48px rgba(0, 0, 0, 0.34),
    0 2px 0 rgba(255, 255, 255, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.28),
    inset 0 -1px 0 rgba(0, 0, 0, 0.20);

  overflow: hidden; /* needed for the light streaks */
  transform: translateZ(0);

  transition:
    opacity 180ms ease,
    transform 220ms cubic-bezier(0.16, 1, 0.3, 1);
}

/* =========================
   Bar Layout Structure
   ========================= */

.glassBar{
  display: flex;
  align-items: center;
  justify-content: space-between; /* <-- key change */
  padding: 8px 18px;              /* more side breathing room */
}

/* Left logo container */
.glassBar__left{
  display: flex;
  align-items: center;
  z-index: 2;
}

/* Logo styling */
.glassBar__logo{
  font-weight: 800;
  font-size: 16px;
  letter-spacing: -0.02em;
  opacity: 0.9;
}

/* Right menu container */
.glassBar__right{
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;          /* spacing between words */
  z-index: 2;
}

/* specular streak + soft vignette like the reference */
.glassBar::before{
  content: "";
  position: absolute;
  inset: -1px;
  border-radius: inherit;
  pointer-events: none;
  z-index: 0;

  background:
    radial-gradient(120% 140% at 18% 0%,
      rgba(255,255,255,0.22) 0%,
      rgba(255,255,255,0.10) 18%,
      rgba(255,255,255,0.00) 55%),
    radial-gradient(120% 140% at 82% 110%,
      rgba(0,0,0,0.18) 0%,
      rgba(0,0,0,0.00) 55%),
    linear-gradient(115deg,
      rgba(255,255,255,0.18) 0%,
      rgba(255,255,255,0.06) 22%,
      rgba(255,255,255,0.00) 42%,
      rgba(255,255,255,0.10) 62%,
      rgba(255,255,255,0.00) 78%);

  mix-blend-mode: screen;
  opacity: 0.9;
}

/* thin rim highlight */
.glassBar::after{
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
  z-index: 0;

  box-shadow:
    inset 0 0 0 1px rgba(255,255,255,0.18),
    inset 0 0 0 2px rgba(255,255,255,0.06);
  opacity: 0.9;
}

/* show/hide (driven by visible prop) */
.glassBar--hide{
  opacity: 0;
  pointer-events: none;
  transform: translateY(18px);
}

.glassBar--show{
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0px);
}

/* green-tinted outer glass on light background */
.glassBar--green{
  /* slightly clearer green glass */
  background: rgba(95, 186, 139, 0.16);
  border-color: rgba(95, 186, 139, 0.55);

  backdrop-filter: blur(10px) saturate(210%) contrast(115%);
  -webkit-backdrop-filter: blur(10px) saturate(210%) contrast(115%);

  box-shadow:
    0 18px 48px rgba(0, 0, 0, 0.24),
    0 2px 0 rgba(255, 255, 255, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.30),
    inset 0 -1px 0 rgba(0, 0, 0, 0.16);

  color: #000000;
}

/* =========================
   Items
   ========================= */
.glassBar__item{
  position: relative;
  z-index: 2;

  height: 40px;
  padding: 0 18px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border-radius: 999px;
  text-decoration: none;

  color: rgba(252, 249, 248, 0.95);

  transition: transform 140ms ease;
  outline: none;
}

.glassBar--green .glassBar__item{
  color: #000000;
}

/*
.glassBar__item:hover{
  transform: translateY(-1px);
}
*/

.glassBar__item:active{
  transform: translateY(0px) scale(0.98);
}

.glassBar__item:focus-visible{
  outline: 2px solid rgba(95, 186, 139, 0.95);
  outline-offset: 3px;
}

/* =========================
   Hover pill (inner capsule)
   ========================= */
.glassBar__hoverPill{
  position: absolute;
  left: 0;
  top: 50%;

  height: 40px;
  border-radius: 999px;

  z-index: 1;
  opacity: 0;

  /* clearer, “wet” highlight capsule */
  background: rgba(255, 255, 255, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.24);

  backdrop-filter: blur(8px) saturate(210%) contrast(115%);
  -webkit-backdrop-filter: blur(8px) saturate(210%) contrast(115%);

  box-shadow:
    0 14px 30px rgba(0, 0, 0, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.32),
    inset 0 -1px 0 rgba(0, 0, 0, 0.18);

  overflow: hidden;
  transform: translateY(-50%) translateX(0px) translateZ(0);

  transition:
    opacity 120ms ease,
    transform 240ms cubic-bezier(0.16, 1, 0.3, 1),
    width 240ms cubic-bezier(0.16, 1, 0.3, 1);
}

.glassBar__hoverPill::before{
  content: "";
  position: absolute;
  inset: -1px;
  border-radius: inherit;
  pointer-events: none;

  background:
    linear-gradient(110deg,
      rgba(255,255,255,0.20) 0%,
      rgba(255,255,255,0.06) 28%,
      rgba(255,255,255,0.00) 52%,
      rgba(255,255,255,0.10) 74%,
      rgba(255,255,255,0.00) 92%);
  mix-blend-mode: screen;
  opacity: 0.9;
}

.glassBar__hoverPill--show{
  opacity: 1;
}

/* =========================
   Hover focus: blur others
   ========================= */
.glassBar:hover .glassBar__item{
  opacity: 0.35;
  filter: blur(2px);
  transition: opacity 140ms ease, filter 160ms ease, transform 140ms ease;
}

.glassBar:hover .glassBar__item:hover{
  opacity: 1;
  filter: blur(0px);
}

.glassBar:focus-within .glassBar__item{
  opacity: 0.35;
  filter: blur(2px);
}

.glassBar:focus-within .glassBar__item:focus{
  opacity: 1;
  filter: blur(0px);
}

/* =========================
   Mobile tweaks
   ========================= */
@media (max-width: 520px){
  .glassBar{
    height: 52px;
    width: calc(100vw - 24px);
    padding: 6px;
  }

  .glassBar__item{
    height: 40px;
    padding: 0 12px;
    font-size: 13px;
  }

  .glassBar__hoverPill{
    height: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pill.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;;8BAE8B;AAC9B;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,YAAY;;EAEZ,aAAa;EACb,aAAa;EACb,uBAAuB;;EAEvB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;;8BAE8B;AAC9B;EACE,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,YAAY;EACZ,oBAAoB;;EAEpB,gDAAgD;EAChD,gBAAgB;EAChB,eAAe;EACf,sBAAsB;;EAEtB,gCAAgC;;EAEhC,kDAAkD;EAClD,qCAAqC;EACrC,2CAA2C;;EAE3C,yDAAyD;EACzD,iEAAiE;;EAEjE,wBAAwB;EACxB;;;;sCAIoC;;EAEpC,gBAAgB,EAAE,iCAAiC;EACnD,wBAAwB;;EAExB;;iDAE+C;AACjD;;AAEA;;8BAE8B;;AAE9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAE,mBAAmB;EACnD,iBAAiB,eAAe,6BAA6B;AAC/D;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ,WAAW,0BAA0B;EAC7C,UAAU;AACZ;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;;EAEV;;;;;;;;;;;;;iCAa+B;;EAE/B,sBAAsB;EACtB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;;EAEV;;0CAEwC;EACxC,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,UAAU;EACV,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,iDAAiD;AACjD;EACE,iCAAiC;EACjC,oCAAoC;EACpC,sCAAsC;;EAEtC,yDAAyD;EACzD,iEAAiE;;EAEjE;;;;sCAIoC;;EAEpC,cAAc;AAChB;;AAEA;;8BAE8B;AAC9B;EACE,kBAAkB;EAClB,UAAU;;EAEV,YAAY;EACZ,eAAe;;EAEf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,oBAAoB;EACpB,qBAAqB;;EAErB,gCAAgC;;EAEhC,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;CAIC;;AAED;EACE,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;8BAE8B;AAC9B;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;;EAER,YAAY;EACZ,oBAAoB;;EAEpB,UAAU;EACV,UAAU;;EAEV,qCAAqC;EACrC,qCAAqC;EACrC,2CAA2C;;EAE3C,wDAAwD;EACxD,gEAAgE;;EAEhE;;;sCAGoC;;EAEpC,gBAAgB;EAChB,yDAAyD;;EAEzD;;;6CAG2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;;EAEpB;;;;;;iCAM+B;EAC/B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;;8BAE8B;AAC9B;EACE,aAAa;EACb,iBAAiB;EACjB,uEAAuE;AACzE;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;;8BAE8B;AAC9B;EACE;IACE,YAAY;IACZ,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* src/pill.css */\n\n/* =========================\n   Bottom dock (fixed)\n   ========================= */\n.glassMenuDock{\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 24px;\n\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n\n  pointer-events: none;\n}\n\n.glassMenuDock > *{\n  pointer-events: auto;\n}\n\n@media (max-width: 520px){\n  .glassMenuDock{\n    bottom: 14px;\n  }\n}\n\n/* =========================\n   Wide glass capsule bar\n   ========================= */\n.glassBar{\n  position: relative;\n  width: min(780px, calc(100vw - 32px));\n  height: 56px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  padding: 8px;\n  border-radius: 999px;\n\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: 0.02em;\n\n  color: rgba(252, 249, 248, 0.95);\n\n  /* LESS FROSTED: lower blur, higher transparency */\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.22);\n\n  backdrop-filter: blur(10px) saturate(190%) contrast(115%);\n  -webkit-backdrop-filter: blur(10px) saturate(190%) contrast(115%);\n\n  /* Liquid edge + depth */\n  box-shadow:\n    0 18px 48px rgba(0, 0, 0, 0.34),\n    0 2px 0 rgba(255, 255, 255, 0.08),\n    inset 0 1px 0 rgba(255, 255, 255, 0.28),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.20);\n\n  overflow: hidden; /* needed for the light streaks */\n  transform: translateZ(0);\n\n  transition:\n    opacity 180ms ease,\n    transform 220ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* =========================\n   Bar Layout Structure\n   ========================= */\n\n.glassBar{\n  display: flex;\n  align-items: center;\n  justify-content: space-between; /* <-- key change */\n  padding: 8px 18px;              /* more side breathing room */\n}\n\n/* Left logo container */\n.glassBar__left{\n  display: flex;\n  align-items: center;\n  z-index: 2;\n}\n\n/* Logo styling */\n.glassBar__logo{\n  font-weight: 800;\n  font-size: 16px;\n  letter-spacing: -0.02em;\n  opacity: 0.9;\n}\n\n/* Right menu container */\n.glassBar__right{\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;          /* spacing between words */\n  z-index: 2;\n}\n\n/* specular streak + soft vignette like the reference */\n.glassBar::before{\n  content: \"\";\n  position: absolute;\n  inset: -1px;\n  border-radius: inherit;\n  pointer-events: none;\n  z-index: 0;\n\n  background:\n    radial-gradient(120% 140% at 18% 0%,\n      rgba(255,255,255,0.22) 0%,\n      rgba(255,255,255,0.10) 18%,\n      rgba(255,255,255,0.00) 55%),\n    radial-gradient(120% 140% at 82% 110%,\n      rgba(0,0,0,0.18) 0%,\n      rgba(0,0,0,0.00) 55%),\n    linear-gradient(115deg,\n      rgba(255,255,255,0.18) 0%,\n      rgba(255,255,255,0.06) 22%,\n      rgba(255,255,255,0.00) 42%,\n      rgba(255,255,255,0.10) 62%,\n      rgba(255,255,255,0.00) 78%);\n\n  mix-blend-mode: screen;\n  opacity: 0.9;\n}\n\n/* thin rim highlight */\n.glassBar::after{\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  pointer-events: none;\n  z-index: 0;\n\n  box-shadow:\n    inset 0 0 0 1px rgba(255,255,255,0.18),\n    inset 0 0 0 2px rgba(255,255,255,0.06);\n  opacity: 0.9;\n}\n\n/* show/hide (driven by visible prop) */\n.glassBar--hide{\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(18px);\n}\n\n.glassBar--show{\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateY(0px);\n}\n\n/* green-tinted outer glass on light background */\n.glassBar--green{\n  /* slightly clearer green glass */\n  background: rgba(95, 186, 139, 0.16);\n  border-color: rgba(95, 186, 139, 0.55);\n\n  backdrop-filter: blur(10px) saturate(210%) contrast(115%);\n  -webkit-backdrop-filter: blur(10px) saturate(210%) contrast(115%);\n\n  box-shadow:\n    0 18px 48px rgba(0, 0, 0, 0.24),\n    0 2px 0 rgba(255, 255, 255, 0.08),\n    inset 0 1px 0 rgba(255, 255, 255, 0.30),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.16);\n\n  color: #000000;\n}\n\n/* =========================\n   Items\n   ========================= */\n.glassBar__item{\n  position: relative;\n  z-index: 2;\n\n  height: 40px;\n  padding: 0 18px;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 999px;\n  text-decoration: none;\n\n  color: rgba(252, 249, 248, 0.95);\n\n  transition: transform 140ms ease;\n  outline: none;\n}\n\n.glassBar--green .glassBar__item{\n  color: #000000;\n}\n\n/*\n.glassBar__item:hover{\n  transform: translateY(-1px);\n}\n*/\n\n.glassBar__item:active{\n  transform: translateY(0px) scale(0.98);\n}\n\n.glassBar__item:focus-visible{\n  outline: 2px solid rgba(95, 186, 139, 0.95);\n  outline-offset: 3px;\n}\n\n/* =========================\n   Hover pill (inner capsule)\n   ========================= */\n.glassBar__hoverPill{\n  position: absolute;\n  left: 0;\n  top: 50%;\n\n  height: 40px;\n  border-radius: 999px;\n\n  z-index: 1;\n  opacity: 0;\n\n  /* clearer, “wet” highlight capsule */\n  background: rgba(255, 255, 255, 0.10);\n  border: 1px solid rgba(255, 255, 255, 0.24);\n\n  backdrop-filter: blur(8px) saturate(210%) contrast(115%);\n  -webkit-backdrop-filter: blur(8px) saturate(210%) contrast(115%);\n\n  box-shadow:\n    0 14px 30px rgba(0, 0, 0, 0.22),\n    inset 0 1px 0 rgba(255, 255, 255, 0.32),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.18);\n\n  overflow: hidden;\n  transform: translateY(-50%) translateX(0px) translateZ(0);\n\n  transition:\n    opacity 120ms ease,\n    transform 240ms cubic-bezier(0.16, 1, 0.3, 1),\n    width 240ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.glassBar__hoverPill::before{\n  content: \"\";\n  position: absolute;\n  inset: -1px;\n  border-radius: inherit;\n  pointer-events: none;\n\n  background:\n    linear-gradient(110deg,\n      rgba(255,255,255,0.20) 0%,\n      rgba(255,255,255,0.06) 28%,\n      rgba(255,255,255,0.00) 52%,\n      rgba(255,255,255,0.10) 74%,\n      rgba(255,255,255,0.00) 92%);\n  mix-blend-mode: screen;\n  opacity: 0.9;\n}\n\n.glassBar__hoverPill--show{\n  opacity: 1;\n}\n\n/* =========================\n   Hover focus: blur others\n   ========================= */\n.glassBar:hover .glassBar__item{\n  opacity: 0.35;\n  filter: blur(2px);\n  transition: opacity 140ms ease, filter 160ms ease, transform 140ms ease;\n}\n\n.glassBar:hover .glassBar__item:hover{\n  opacity: 1;\n  filter: blur(0px);\n}\n\n.glassBar:focus-within .glassBar__item{\n  opacity: 0.35;\n  filter: blur(2px);\n}\n\n.glassBar:focus-within .glassBar__item:focus{\n  opacity: 1;\n  filter: blur(0px);\n}\n\n/* =========================\n   Mobile tweaks\n   ========================= */\n@media (max-width: 520px){\n  .glassBar{\n    height: 52px;\n    width: calc(100vw - 24px);\n    padding: 6px;\n  }\n\n  .glassBar__item{\n    height: 40px;\n    padding: 0 12px;\n    font-size: 13px;\n  }\n\n  .glassBar__hoverPill{\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
